module.exports = __webpack_public_path__ + "img/Logo incen.2e57d76f.png";